import { AddressSuggestion } from '../types/AddressSuggestion';

export const formatSuggestion = (suggestion: AddressSuggestion): string => {
  return `${suggestion.street_line}, ${suggestion.city}, ${suggestion.state} ${suggestion.zipcode}`;
};
